interface ButtonContainerProps {
  firstButton?: React.ReactNode;
  secondButton?: React.ReactNode;
  formBreak?: React.ReactNode;
}

const ButtonContainer: React.FC<ButtonContainerProps> = ({
  firstButton,
  secondButton,
  // formBreak,
}) => {
  return (
    <div className="w-full flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-4 mt-4">
      {firstButton && (
        <div className="w-full md:w-1/2 flex justify-center">{firstButton}</div>
      )}
      {/**Removing until Log in with Google button is used*/}
      {/* {formBreak && (
        <div className="w-full md:hidden flex justify-center">{formBreak}</div>
      )} */}
      {secondButton && (
        <div className="w-full md:w-1/2 flex justify-center">{secondButton}</div>
      )}
    </div>
  );
};

export default ButtonContainer;
